import { render, staticRenderFns } from "./UserAddModal.vue?vue&type=template&id=85bb9c8a"
import script from "./UserAddModal.vue?vue&type=script&lang=js"
export * from "./UserAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports